export default __webpack_public_path__ + "static/heroSectionImg-c3f1b19893e24b542fdd6254de12b734.webp";